import script from "./ContactUsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactUsPage.vue?vue&type=script&setup=true&lang=ts"

import "./ContactUsPage.vue?vue&type=style&index=0&id=620ed9a3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-620ed9a3"]])

export default __exports__